import { useAuth } from "@clerk/clerk-react";
import PopUp from "Components/PopUp/PopUp";
import RadioButtonGroup from "Components/RadioButtonGroup/RadioButtonGroup";
import { Button } from "Components/ui/button";
import { Separator } from "Components/ui/separator";
import useCountdown from "hooks/use-countDown";
import { CreditCard, Wallet } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { calculateSignature } from "utils";
import bitcoin from "../../../../Assets/Images/bitcoin.svg";
import usd from "../../../../Assets/Images/usd.png";
import {
  payFromWallet,
  purchaseAddon,
  skrillPurchaseAddon,
  stripePurchaseAddon,
} from "../../../../Redux/ChallengeRules/ChallengeRulesActions";
import {
  getCryptoChillProfile,
  getRates,
} from "../../../../Redux/CryptoChill/CryptoChillAction";
import CryptoChillPopup from "./CryptoChillPopup";
// import CryptoChillPopup from "./CryptoChillPopup";

function CheckoutPopup({ open, setOpen, totalAmount, title }) {
  const [paymentMethod, setPaymentMethod] = useState("CC");
  const [currency, setCurrency] = useState("USD");
  const [paymentProvider, setPaymentProvider] = useState("STRIPE");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [step, setStep] = useState(1);

  const { user } = useSelector((state) => state.ProfileReducer);
  const {
    profile,
    rates,
    createInvoiceSuccess,
    invoice,
    qrCode,
    createInvoiceLoading,
    getRatesLoading,
    getQRCodeLoading,
    getInvoiceLoading,
    getProfileLoading,
  } = useSelector((state) => state.InvoiceReducer);

  const { payablePaymentSuccess, payablePaymentLoading } = useSelector(
    (state) => state.ChallengeSetupReducer
  );

  const {
    payFromWalletLoading,
    payFromWalletError,
    payFromWalletSuccess,
    addonPurchased,
    purchaseAddonSuccess,
    skrillPurchaseLoading,
    skrillPurchaseSuccess,
    skrillPurchaseError,
    skrillPurchase,
    purchaseAddonLoading,
  } = useSelector((state) => state.ChallengeRulesReducer);

  const {
    stripePurchaseLoading,
    stripePurchaseSuccess,
    stripePurchaseError,
    stripePurchase,
  } = useSelector((state) => state.ChallengeRulesReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [ip, setIp] = useState("");
  const [openCrypto, setOpenCrypto] = useState(false);

  useEffect(() => {
    if (payablePaymentSuccess) {
      setOpen(false);
    }
  }, [payablePaymentSuccess]);

  const { getToken } = useAuth();
  const { id } = useParams();

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP address:", error));
  }, []);

  const { formattedTime, progress, restart } = useCountdown(
    invoice?.result?.expires_at
  );

  //payable payment function

  const handlePayment = async () => {
    console.log(title);
    if (paymentMethod === "CC") {
      if (paymentProvider === "STRIPE") {
        const type =
          title === "News Trading"
            ? "News"
            : title === "Retry Challenge"
            ? "Retry Challenge"
            : "";
        const data = {
          type: type,
          challengeId: id,
        };

        dispatch(stripePurchaseAddon(getToken, data, navigate));
      } else if (paymentProvider === "PAYABL") {
        const type =
          title === "News Trading"
            ? "News"
            : title === "Retry Challenge"
            ? "Retry Challenge"
            : "";
        const data = {
          customerip: ip,
          type: type,
          currency: currency,
          challengeId: id,
        };

        if (ip && currency && id && type) {
          dispatch(purchaseAddon(getToken, data, setOpen));
        }
      } else if (paymentProvider === "Skrill") {
        const type =
          title === "News Trading"
            ? "News"
            : title === "Retry Challenge"
            ? "Retry Challenge"
            : "";
        const data = {
          type: type,
          challengeId: id,
        };
        dispatch(skrillPurchaseAddon(getToken, data));
      }
    } else if (paymentMethod === "wallet") {
      const type =
        title === "News Trading"
          ? "News"
          : title === "Retry Challenge"
          ? "Retry Challenge"
          : "";
      dispatch(payFromWallet(getToken, id, type, setOpen));
    } else {
      setPaymentStatus("");
      setStep(1);
      setOpenCrypto(true);
      dispatch(
        getCryptoChillProfile(getToken, process.env.REACT_APP_CRYPTO_ADDON)
      );
      dispatch(getRates(getToken));
    }
  };
  useEffect(() => {
    if (stripePurchaseSuccess) {
      setOpen(false);
    }
  }, [stripePurchaseSuccess]);

  useEffect(() => {
    if (addonPurchased && purchaseAddonSuccess) {
      const params = new URLSearchParams(addonPurchased?.message);
      const obj = {};
      for (const [key, value] of params.entries()) {
        obj[key] = value;
      }

      const url = obj?.start_url;
      if (url) window.location.href = url;
    }
  }, [addonPurchased, purchaseAddonSuccess]);

  useEffect(() => {
    if (skrillPurchaseSuccess && skrillPurchase) {
      const url = skrillPurchase?.paymentUrl;
      if (url) window.location.href = url;
    }
  }, [skrillPurchase, skrillPurchaseSuccess]);

  return (
    <PopUp open={open} setOpen={setOpen} title="Checkout" className="flex sm:flex-row flex-col">
      <div className="sm:w-[45%] w-full mb-10 mt-5">
        <div>
          <div className="text-[20px] font-G_SemiBold mb-4">Payment Method</div>
          <RadioButtonGroup
            noIcon
            grid={2}
            uniqueName={"paymentMethod"}
            data={[
              {
                label: (
                  <div className="flex flex-col gap-2 items-start text-lightBlue">
                    <CreditCard />
                    <div>Credit Card</div>
                  </div>
                ),
                value: "CC",
              },
              {
                label: (
                  <div className="flex flex-col gap-2 items-start text-lightBlue">
                    <img src={bitcoin} alt="USD" className="w-6" />
                    <div>Crypto</div>
                  </div>
                ),
                value: "CC2",
              },
              {
                label: (
                  <div className="flex flex-col gap-2 items-start text-lightBlue">
                    <Wallet className="w-6" />
                    <div>
                      Wallet (
                      {user?.Wallet?.balance?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })}
                      )
                    </div>
                  </div>
                ),
                value: "wallet",
              },
            ]}
            checked={paymentMethod}
            setChecked={setPaymentMethod}
          />
        </div>
        {/* {paymentMethod == "CC" && (
          <div>
            <div className="text-[20px] font-G_SemiBold mb-4 mt-10">
              Choose Your N_Mediumethod
            </div>
            <RadioButtonGroup
              grid={2}
              uniqueName={"paymentProvider"}
              data={[
                {
                  label: (
                    <div className="flex gap-2 items-center">
                      <div>Stripe</div>
                    </div>
                  ),
                  value: "STRIPE",
                },
                // {
                //   label: (
                //     <div className="flex gap-2 items-center">
                //       <div>Visa/MC</div>
                //     </div>
                //   ),
                //   value: "PAYABL",
                // },
                // {
                //   label: (
                //     <div className="flex gap-2 items-center">
                //       <div>Neteller</div>
                //     </div>
                //   ),
                //   value: "NETELLER",
                // },
                // {
                //   label: (
                //     <div className="flex gap-2 items-center">
                //       <div>Skrill</div>
                //     </div>
                //   ),
                //   value: "Skrill",
                // },
              ]}
              checked={paymentProvider}
              setChecked={setPaymentProvider}
            />
          </div>
        )} */}
        <div>
          <div className="text-[20px] font-G_SemiBold mt-10 mb-4">
            Payment Currency
          </div>
          <RadioButtonGroup
            grid={2}
            uniqueName={"paymentInfo"}
            data={[
              {
                label: (
                  <div className="flex gap-2 items-center">
                    <img src={usd} alt="USD" className="w-6" />
                    <div>USD</div>
                  </div>
                ),
                value: "USD",
              },
            ]}
            checked={currency}
            setChecked={setCurrency}
          />
        </div>
      </div>
      <div className="sm:w-[45%] w-full mt-5">
        <div className="text-[20px] font-G_SemiBold">Summary</div>
        <div className="flex flex-col gap-2 mt-5">
          <div className="flex flex-row justify-between items-center gap-4">
            <div className="text-sm font-G_Regular opacity-50">{title}</div>
            <div className="text-sm font-G_Regular opacity-50">
              {totalAmount?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 3,
              })}
            </div>
          </div>
        </div>
        <Separator className="my-6" />
        <div className="flex flex-row items-center justify-between gap-4">
          <div className="text-base font-G_Regular">TOTAL</div>
          <div className="text-base font-G_Regular">
            {" "}
            {totalAmount?.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 3,
            })}
          </div>
        </div>
        <Button
          className="w-full mt-10"
          onClick={() => {
            handlePayment();
          }}
          disabled={
            !paymentMethod ||
            payFromWalletLoading ||
            payablePaymentLoading ||
            purchaseAddonLoading ||
            stripePurchaseLoading ||
            skrillPurchaseLoading
          }
        >
          {payablePaymentLoading ||
          payFromWalletLoading ||
          purchaseAddonLoading ||
          skrillPurchaseLoading ||
          stripePurchaseLoading
            ? "Loading..."
            : "Pay Now"}
        </Button>
        {open && (
          <CryptoChillPopup
            open={openCrypto}
            setOpen={setOpenCrypto}
            step={step}
            setStep={setStep}
            totalAmount={totalAmount}
            selectedCurrency={currency}
            id={id}
            type={
              title === "News Trading"
                ? "News"
                : title === "Retry Challenge"
                ? "Retry Challenge"
                : ""
            }
          />
        )}
      </div>
    </PopUp>
  );
}

export default CheckoutPopup;
